import { render, staticRenderFns } from "./btn-link.vue?vue&type=template&id=59222cd5&scoped=true"
import script from "./btn-link.vue?vue&type=script&lang=ts"
export * from "./btn-link.vue?vue&type=script&lang=ts"
import style0 from "./btn-link.vue?vue&type=style&index=0&id=59222cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59222cd5",
  null
  
)

export default component.exports